import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReleaseNotes } from '../../../configuration/models/release-notes.model';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.scss'],
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule, MatListModule]
})
export class ReleaseNotesComponent {
  @HostBinding('attr.data-testid') dataTestId = 'modal-release-notes';
  constructor(
    public dialogRef: MatDialogRef<ReleaseNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReleaseNotes
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
